import React from "react";
export default function IconCube() {
    return /*#__PURE__*/ React.createElement("svg", {
        width: "50",
        height: "50",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: "0.21",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 30V37C0 49.7025 10.2975 60 23 60H30H37C49.7025 60 60 49.7025 60 37V30V23C60 10.2975 49.7025 0 37 0H30H23C10.2975 0 0 10.2975 0 23V30Z",
        fill: "#FEC53D"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 24.3162L27.9005 31.7643C28.0394 31.8445 28.1851 31.9024 28.3333 31.9392V46.3844L15.9201 39.0382C15.3498 38.7007 15 38.0873 15 37.4246V24.3162ZM45 24.1182V37.4246C45 38.0873 44.6502 38.7007 44.0799 39.0382L31.6667 46.3844V31.8126C31.6969 31.7975 31.7269 31.7814 31.7566 31.7643L45 24.1182Z",
        fill: "#FEC53D"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.499209",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4043 20.7014C15.5619 20.5024 15.7608 20.3343 15.9926 20.2108L29.1176 13.2201C29.6686 12.9266 30.3295 12.9266 30.8805 13.2201L44.0055 20.2108C44.1843 20.306 44.3434 20.4277 44.4791 20.5697L30.089 28.8778C29.9943 28.9325 29.9071 28.995 29.8276 29.064C29.7481 28.995 29.6609 28.9325 29.5662 28.8778L15.4043 20.7014Z",
        fill: "#FEC53D"
    }));
}
